import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=aa2b150a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=aa2b150a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2b150a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa2b150a')) {
      api.createRecord('aa2b150a', component.options)
    } else {
      api.reload('aa2b150a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=aa2b150a&scoped=true&", function () {
      api.rerender('aa2b150a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25sdy7AQ8rsNt/JS/comp/GuestBox.vue"
export default component.exports